import { queryClient, apiRequest } from "../lib/queryClient";

const adsKey = "ads";

export function useAds(options = {}) {
  const {
    filters = {},
    sort = { field: "created_at", direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchAds = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    }

    const response = await apiRequest(`/admin/ads/?${queryParams.toString()}`, {
      method: "GET",
    });
    return response;
  };

  const createAds = async (adsData) => {
    const response = await apiRequest("/admin/ads", {
      method: "POST",
      body: JSON.stringify(adsData),
    });
    queryClient.invalidateQueries({ queryKey: [adsKey] });
    return response;
  };

  const updateAds = async (adsData) => {
    const response = await apiRequest(`/admin/ads`, {
      method: "PUT",
      body: JSON.stringify(adsData),
    });
    queryClient.invalidateQueries({ queryKey: [adsKey] });
    return response;
  };

  const deleteAds = async (id) => {
    await apiRequest(`/admin/ads/${id}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [adsKey] });
    return id;
  };

  const toggleAdsConfiguration = async (adsData) => {
    const response = await apiRequest(`/admin/ads/config/`, {
      method: "PUT",
      body: JSON.stringify(adsData),
    });
    queryClient.invalidateQueries({ queryKey: [adsKey] });
    return response;
  };

  return {
    fetchAds,
    createAds,
    updateAds,
    deleteAds,
    toggleAdsConfiguration,
  };
}
